module.exports = __webpack_public_path__ + "e254cd67aab086c9a6350509c95772de.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/linkedin.png
 ** module id = 427
 ** module chunks = 0
 **/